export default {
  desktop: {
    LiveThemeImporter: () => import(/* webpackChunkName: "reisbet-themeWrapLive" */'./LiveThemeImporter'),
  },
  mobile: {
    LiveThemeImporter: () => import(/* webpackChunkName: "reisbet-themeWrapLive" */'./LiveThemeImporter'),
  },
};
